// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateDealerAccounts = (dealer, isSelected) =>
    dispatch => {

        dispatch({
            data: false,
            type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
        });

        dispatch({
            dealer,
            isSelected,
            type: actions.UPDATE_USER_PREFERENCES_DEALER_ACCOUNTS
        });

    };

export const updateDealerDisplayFormat = (key, list) =>
    dispatch => {

        dispatch({
            data: false,
            type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
        });

        dispatch({
            displayFormat: list.find(item => item.key === key),
            type: actions.UPDATE_USER_PREFERENCES_DEALER_DISPLAY_FORMAT
        });

    };

export const toggleAllAccounts = dealers =>
    dispatch => {

        dispatch({
            data: false,
            type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
        });

        dispatch({
            dealers,
            type: actions.UPDATE_USER_PREFERENCES_ALL_DEALER_ACCOUNTS
        });

    };



// WEBPACK FOOTER //
// ./src/user/shared/action-creators/dealer-settings.js